var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "28", height: "26", viewBox: "0 0 28 26", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M48.833 28C51.687 28 54 30.453 54 33.478 54 39.038 44 46 44 46s-10-6.88-10-12.522C34 30.453 36.313 28 39.167 28c2.21 0 4.094 1.472 4.833 3.539.739-2.067 2.623-3.539 4.833-3.539zm-9.059 2.455c-1.863 0-3.374 1.545-3.374 3.45 0 .354.28.64.626.64a.633.633 0 0 0 .626-.64c0-1.198.95-2.17 2.122-2.17a.633.633 0 0 0 .626-.64c0-.354-.28-.64-.626-.64z", id: "regret-swipe-path-1" }),
      React.createElement(
        "filter",
        { x: "-35%", y: "-27.8%", width: "170%", height: "177.8%", filterUnits: "objectBoundingBox", id: "regret-swipe-filter-2" },
        React.createElement("feOffset", { dy: "2", "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
        React.createElement("feGaussianBlur", { stdDeviation: "2", "in": "shadowOffsetOuter1", result: "shadowBlurOuter1" }),
        React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0", "in": "shadowBlurOuter1" })
      )
    ),
    React.createElement(
      "g",
      { transform: "translate(-30 -26)", fillRule: "nonzero", fill: "none" },
      React.createElement("use", { fill: "#000", filter: "url(#regret-swipe-filter-2)", xlinkHref: "#regret-swipe-path-1" }),
      React.createElement("use", { fill: "#FF4DC4", xlinkHref: "#regret-swipe-path-1" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/shared/components/RegretSwipeAlert/heart.svg